import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';
import './SelfieVerification.styles.scss';
import SelfieWizard from './SelfieWizard/SelfieWizard';
import withContainer from '../../containers/WithContainer';
import { ContainerNew } from '../../containers/AppContainer';
import { withRouter } from 'react-router-dom';
interface SelfieVerificationProps {
  appContainer: ContainerNew;
  match: any;
}

interface SelfieVerificationState {
  isSnapshotSelected: boolean;
  capturedImages: string[];
  imageCode: string[];
  code: string;
}

class SelfieVerification extends React.Component<
  SelfieVerificationProps,
  SelfieVerificationState
> {
  public messageMapping = [];
  public imgRef: HTMLDivElement = null;

  constructor(props) {
    super(props);
    this.state = {
      isSnapshotSelected: false,
      capturedImages: [],
      imageCode: [],
      code: '',
    };
    this.messageMapping = [
      'Great! 2 more to go',
      'Nice! 1 more now',
      "Cool, you're all set!",
    ];
  }

  componentDidMount() {
    let imageCode = this.props.appContainer.generateCodeImages();
    this.setState({
      imageCode: imageCode.images,
      code: imageCode.code,
    });
  }

  handleSnapshotSelect = img => {
    const capturedImages = [img];
    this.setState({ capturedImages });
  };

  onNext = () => {
    this.props.appContainer.updateVerificationStep(this.getCurrStep());
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  public render() {
    const { capturedImages, isSnapshotSelected } = this.state;
    return (
      <WizardCard
        title="Let's confirm your profile photo is you"
        delay={2.5}
        isDisabled={!capturedImages.length}
        nextLabel="Next"
        onNext={this.onNext}
      >
        <Appear delay={2}>
          {!capturedImages.length && (
            <div className="flex-row justify-center">
              {/*   <div>
                Take a selfie as shown below <br />
                Don't use any filters <br />
                Keep your whole face visible
            </div> */}
            </div>
          )}

          <SelfieWizard
            selectedImages={capturedImages}
            exampleImages={this.state.imageCode}
            stepTitles={[]}
            code={this.state.code}
            onSelect={this.handleSnapshotSelect}
          />

          {/* <div className="has-padding-10 columns is-mobile flex-row justify-center">
            {
              capturedImages.map(img => (
                <Appear key={img.toString()} className="column is-9-mobile">
                  <img src={img} alt="Captured Image" className="is-flipped-x is-covering-container is-hidden-touch" />
                  <img src={img} alt="Captured Image" className="is-hidden-desktop is-covering-container" />
                </Appear>
              ))
            }
          </div> */}
        </Appear>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(SelfieVerification));
